import React, { Component } from 'react';
import './info-card.scss';

class InfoCard extends Component {
  render() {
    return (
      <div className="info-card" style={{backgroundColor: this.props.backgroundColor}}>
        <div className="card-content">
          <div>
            <img className="card-img" src={this.props.cardImg} alt=""/>
            <i className={this.props.fontAwesomeClass + " icon"} style={{color: this.props.iconcolor}}></i>
            <h1 className="card-title">{this.props.cardTitle}</h1>
            <p className="card-text">{this.props.cardText}</p>
          </div>
        </div>
      </div>
    );
  }
}

export default InfoCard;



// WEBPACK FOOTER //
// ./src/components/info-card/info-card.js